<template>
    <div :class="['editable-cell', background ? 'none' : 'bg']">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input-number style="width: 100%" :step="step" :autoFocus="true" :max="max" class="text" :min="min" size="small" v-model="val" @blur="blur" @pressEnter="e => e.target.blur()" />
        </div>
        <div class="editable-cell-text-wrapper" :class="color"  @click="edit" v-else>
          <a-spin :spinning="loading" size="small" class="spinning-block">
            <!-- <span :class="color">
              {{text|numberFixed(len)}}
            </span> -->
            <span :class="isBlue? 'blue  color': 'color' " >
              {{ text|numberFixed(len)}} 
            </span>
          </a-spin>
        </div>
        <a-tooltip v-if="warningIcon && !editable">
          <template slot="title">
            {{item.rawName}}的最小值 > 最大值
          </template>
          <a-icon class="warningStyle" type="close-circle" theme="twoTone" two-tone-color="#ff0000" />
        </a-tooltip>
    </div>
</template>

<script>
export default {
  props:['text','item', 'name', 'actions','background','len'],
  data(){
    return {
      val:undefined,
      target:null,
      editable:false,
      loading:false,
      isBlue:false,
    }
  },
  computed:{
    color(){
      const {item,name,text} = this
      const {content,percentage,maxLimitValue,minLimitValue,maxValue,minValue} = item
      const val =  text === '' || text === null ? text : Number(text).toFixed(this.len)
      const red = (val === content || text === percentage) && ((name === 'maxLimitValue' && maxLimitValue !== '') || (name === 'maxValue' && maxValue !== ''))
      const green = (val === content || text === percentage) && ((name === 'minValue' && minValue !== '') || (name === 'minLimitValue' && minLimitValue !== ''))
      return {
        red,green,redBg:red,greenBg:green
      }
    },

    min(){
      return this.name === 'maxLimitValue' || this.name ===  'minLimitValue' || this.name === 'maxValue' || this.name ===  'minValue' ? -99999999999 : 0
    },
    // min(){
    //   return this.name === 'price' ? 0 : -99999999999
    // },
    max(){
      return this.name === 'maxLimitValue' || this.name ===  'minLimitValue' || this.name === 'maxValue' || this.name ===  'minValue' ? 99999999999 : 999999999999.999
    },

    defaultText(){
      const textValue = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(3)
      return textValue
    },
    step(){
      const num = [1,0.1,0.01,0.001,0.0001]
      return num[this.len]
    },
    unit(){
      return this.len
    },
    warningIcon(){
      let flag = false
      if(this.name == 'minValue' || this.name == 'maxValue') {
        if((this.item.minValue || this.item.minValue === 0) && (this.item.maxValue || this.item.maxValue === 0) && (Number(this.item.minValue) > Number(this.item.maxValue))){
          flag = true
        }
      }
      return flag
    },
  },
  methods:{
    blur(){
      this.isBlue=true

      this.editable = false
      // 最值约束数值必须≥0，最小值或最大值 < 0 时默认更新为0
      if((this.name === 'minValue' || this.name === 'maxValue') && this.val !== null && Number(this.val) < 0){
        this.val = 0
      }
      let target = {...this.item}
      if(this.text === this.val) return
      if(this.checkValue(this.val)){
        if(this.val < 0 && this.name === 'price'){
          this.$message.warn('价格不能为负数')
        }
        if(target[this.name] !== this.val || this.val === ''){
          target[this.name] = this.name === 'price' ? this.val.toFixed(3) : this.val
          this.target = target
          this.update()
        }
      }
    },
    
    checkValue(val){
      const {name,item} = this
      if(val === null){
        return true
      } else if((name==="minLimitValue" && val > item.maxLimitValue && (item.maxLimitValue || item.maxLimitValue === 0))
      || (name==="maxLimitValue" && item.minLimitValue > val) 
      || (name==="maxValue" && item.minValue > val) 
      || (name==="minValue" && val > item.maxValue && (item.maxValue || item.maxValue === 0))) {
        this.errorMessage()
        return false
      } else {
        return true
      }
    },
    async update(){
      this.$nextTick(async() => {
        if(this.actions){
          this.loading = true
          await this.actions(this.target,this.name,true)
          this.loading = false
          this.$emit('blur',this.target)
        } else {
          this.loading = false
          this.$emit('blur',this.target)
        }
      })
    },
    change(val){
      this.val = val
    },
    edit(){
      this.editable = true
      this.val = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(this.len)
    },
    errorMessage(){
      const msg = this.name ==='minLimitValue' || this.name === 'maxLimitValue' ? '极下限不能大于极上限' :'最小值不能大于最大值'
      this.$message.warn(msg)
    }
  }
  }
</script>